/* Oct 13 2026 — flag when the sticky purchase bar is on screen so CSS can lift the chat bubble. */
(function () {
  var bar = document.getElementById('cyra-sticky-atc');
  if (!bar) return;
  var root = document.documentElement;
  function sync() {
    var on = bar.classList.contains('visible');
    root.classList.toggle('cyra-sticky-on', on);
    root.style.setProperty('--cyra-sticky-h', on ? bar.offsetHeight + 'px' : '0px');
  }
  new MutationObserver(sync).observe(bar, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('resize', sync, { passive: true });
  sync();
})();
